<h2 mat-dialog-title>{{(this.data.action == 'create' ? 'analisis.vulnerabilidades.form.indicadores.create_text' :
  'analisis.vulnerabilidades.form.indicadores.view') | translate}}</h2>
<form [formGroup]="form">
  <div mat-dialog-content fxLayout="row" fxLayoutGap="15px">
    <div [fxFlex]="'100%'" class="p-2">
      <mat-form-field class="col-md-12" [floatLabel]="'always'">
        <mat-label for="NOMBRE">{{'analisis.vulnerabilidades.form.indicadores.NOMBRE' | translate }}
        </mat-label>
        <input id="NOMBRE" matInput formControlName="NOMBRE" [attr.disabled]="!editable"/>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="data.action !== 'view'" mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button *ngIf="data.action=='edit'" color="warn" mat-button
            [mat-dialog-close]="{data:form.value,action:'delete'}">
      {{'analisis.vulnerabilidades.form.indicadores.delete' | translate}}
    </button>
    <button mat-button [mat-dialog-close]="null">{{'analisis.vulnerabilidades.form.indicadores.cancel' | translate}}</button>
    <button color="accent" mat-button [mat-dialog-close]="{data:form.value,action:data.action}">{{(this.data.action ==
      'create' ?
      'analisis.vulnerabilidades.form.indicadores.create_text' : 'analisis.vulnerabilidades.form.indicadores.edit') | translate}}
    </button>
  </div>
  <div *ngIf="data.action === 'view'" mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button [mat-dialog-close]="null">{{'analisis.vulnerabilidades.form.indicadores.close' | translate}}</button>
  </div>
</form>
